import { setBannerAPIRequestState, userInviteError } from '../effects/message';
import { handleEffects } from '../utils/store';

const initialState = {
  bannerState: null,
  bannerMessage: '',
  userInviteErrorEmail: null,
};

export default handleEffects(
  {
    [setBannerAPIRequestState]: (state, action) => ({
      ...state,
      bannerState: action.payload.bannerState,
      bannerMessage: action.payload.bannerMessage,
    }),
    [userInviteError]: (state, action) => ({
      ...state,
      userInviteErrorEmail: action.payload,
    }),
  },
  initialState,
);
